import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { AddSvg, MinusSvg } from "assets/images/common/svgs";
import useTeamMembers from "containers/team-management/useHooks";
import { useSelector } from "react-redux";

type FormValues = {
  name: string;
  permissionIds: number[];

};


const CreateRole: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>({});
  const { getAllRolePermissions, addRolePermission } = useTeamMembers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [expanded, setExpanded] = useState<string | null>("");
  const [formData, setFormData] = useState<{ permissions: number[] }>({
    permissions: [],
  });

  useEffect(() => {
    const fetchPermissions = async () => {
      await getAllRolePermissions((res: any) => {
        setData(res);

        const allPermissions = Object.values(res).flatMap((permArray: any[]) =>
          permArray.map((item) => item?.action || "")
        );

        // console.log("All Permissions:", allPermissions);
      });
    };

    fetchPermissions();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const handlePermissionChange = (permissionId: number) => {
    setFormData((prev) => {
      const isSelected = prev.permissions.includes(permissionId);
      const updatedPermissions = isSelected
        ? prev.permissions.filter((id) => id !== permissionId)
        : [...prev.permissions, permissionId];
      return { ...prev, permissions: updatedPermissions };
    });
  };


  const toggleExpand = (groupTitle: string) => {
    setExpanded((prev) => (prev === groupTitle ? null : groupTitle));
  };

  const handleBack = () => {
    navigate(-1);
  };

  const onSubmit = (data: FormValues) => {
    const payload = {
      name: data.name,
      permissionIds: formData.permissions,
    };

    addRolePermission(payload); 
  };


  return (
    <div>
      <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
        <span
          onClick={handleBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        Create new Role
      </h1>

      <div className="w-full bg-white p-4 rounded-[8px]">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col gap-3 mt-3"
        >
          {/* Form Fields */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
            {/* Role Title */}
            <div className="flex flex-col gap-2">
              <label className="text-labelText">Role Title</label>
              <input
                type="text"
                placeholder="Enter Role Title"
                {...register("name", {
                  required: "Role Title is required",
                })}
                className="w-full h-[51px] px-4 border border-gray-300 rounded-lg outline-none"
              />
              {errors.name && (
                <span className="text-red-500 text-sm">
                  {errors.name.message}
                </span>
              )}
            </div>

          </div>

          {/* Permissions */}
          <div className="mt-4">
            <p className="font-bold text-primaryText mb-2">Permissions</p>
            {Object.entries(data).map(([groupTitle, permissionsArray]: [string, any[]]) => (
              <div
                key={groupTitle}
                className="border-b border-borderLightGray py-4"
              >
                <div
                  onClick={() => toggleExpand(groupTitle)}
                  className="flex justify-between items-center cursor-pointer"
                >
                  <span className="font-medium capitalize">{groupTitle.replace(/-/g, " ")}</span>
                  <span>
                    {expanded === groupTitle ? <MinusSvg /> : <AddSvg />}
                  </span>
                </div>

                {expanded === groupTitle && permissionsArray?.length > 0 && (
                  <div className="flex items-start justify-center flex-col gap-1 mt-3">
                    {permissionsArray.map((permission: any) => (
                      <label
                        key={permission?.id}
                        className="text-labelText flex items-center gap-2"
                      >
                        <input
                          type="checkbox"
                          checked={formData.permissions.includes(permission?.id)}
                          onChange={() => handlePermissionChange(permission?.id)}
                          className="custom-checkbox"
                        />
                        {permission?.action}
                      </label>

                    ))}
                  </div>
                )}
              </div>
            ))}

          </div>

          {/* Submit Button */}
          <div className="flex justify-start mt-5">
            <button
              type="submit"
              className="w-[125px] h-[45px] text-xl font-semibold text-white bg-darkTealBlue rounded-[8px]"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateRole;
